import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import * as yup from 'yup';
import { Button, Input, useToast } from '@netfront/ui-library';
import { IForgotPasswordFormFields } from './ForgotPasswordForm.interfaces';
import { IForgotPasswordOnCompletedResponse, useForgotPassword } from '@netfront/gelada-identity-library';

export const ForgotPasswordForm = () => {
  const { push } = useRouter();
  const { handleToastError } = useToast();

  const handleForgotPasswordCompleted = ({ isCompleted }: IForgotPasswordOnCompletedResponse) => {
    if (!isCompleted) return;
    push('/forgot-password-sent');
  };

  const { handleForgotPassword, isLoading: isSubmitting = false } = useForgotPassword({
    onCompleted: handleForgotPasswordCompleted,
    onError: (error) => {
      handleToastError({
        error,
        shouldUseFriendlyErrorMessage: true,
      });
    },
  });

  const formik = useFormik<IForgotPasswordFormFields>({
    initialValues: {
      email: '',
    },
    validationSchema: yup.object().shape({
      email: yup.string().email('Please enter a valid email address').required('Please enter in a valid email address'),
    }),
    onSubmit: async ({ email }: IForgotPasswordFormFields) => {
      handleForgotPassword({
        email,
      });
    },
  });

  const { errors, touched, handleBlur, handleChange, handleSubmit } = formik;

  return (
    <form onSubmit={handleSubmit}>
      <Input
        errorMessage={touched.email && errors.email ? errors.email : ''}
        id="email"
        labelText="Email"
        placeholder="Enter email"
        name="email"
        onBlur={handleBlur}
        onChange={handleChange}
        type="email"
        isRequired
      />

      <div className="text-right mb-8">
        <Button variant="accent" text="Send reset link" type="submit" isLoading={isSubmitting} />
      </div>
    </form>
  );
};
